"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var ShadowsSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M9,2 C12.8659932,2 16,5.13400675 16,9 C16,12.7854517 12.9952166,15.8690987 9.24064975,15.995941 L9,16 C5.13400675,16 2,12.8659932 2,9 C2,5.13400675 5.13400675,2 9,2 Z M9,14 L5.68361312,14.000936 C6.57528556,14.5934367 7.63451515,14.9538252 8.77506174,14.9958615 L9,15 L9,14 Z M9,11 L3.34165389,11.0006859 C3.60519414,11.74602 4.01182845,12.4237442 4.52854515,13.0008469 L9,13 L9,11 Z M3.08302748,7.99958857 C3.02842275,8.3249267 3,8.65914411 3,9 C3,9.34099399 3.02844579,9.67534412 3.08309386,10.0008069 L9,10 L9,8 L3.08302748,7.99958857 Z M9,5 L4.52766929,5.0001315 C4.01114782,5.5772688 3.60469721,6.2549814 3.34131557,7.00027121 L9,7 L9,5 Z M9,3 C7.77337384,3 6.63271871,3.36808573 5.68246421,3.99982758 L9,4 L9,3 Z" })));
};
ShadowsSmall.displayName = 'ShadowsSmall';
exports.default = ShadowsSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=ShadowsSmall.js.map